import React from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";

import { MainContext } from "../App";
import Checker from "../Utils/checker";

import Wrapper from "../Styles/wrapper";
import Grid, { Title, Active } from "../Styles/grid";

import config from "../Config/sizes";

const length = ({ match, location }) => {
  const { params: part } = match;
  const usage = part.usage || "standard";

  let hexBit = null;
  const bitSplit = part.bit.split("-");
  if (bitSplit[0] === "hex") {
    hexBit = false;
  } else {
    hexBit = bitSplit[1];
  }

  if (location.pathname !== `/${part.bit}/${usage}/`) {
    return (
      <>
        <MainContext.Consumer key={part.bit}>
          {context => (
            <Link to={`/${part.bit}/${usage}/`} replace>
              <Wrapper grey>
                <Grid dual grey>
                  {Object.values(
                    config.find(type => type.Type === `${usage}`).Sizes
                  ).map(items => {
                    if (items.bitLength === `${context.lengs}`) {
                      return (
                        <Active key={new Date()}>
                          <Title>{items.bitLabel}</Title>
                        </Active>
                      );
                    } else {
                      return (
                        <button key={Math.random()}>
                          <Title>{items.bitLabel}</Title>
                        </button>
                      );
                    }
                  })}
                </Grid>
              </Wrapper>
            </Link>
          )}
        </MainContext.Consumer>
      </>
    );
  }
  return (
    <>
      <MainContext.Consumer key={part.bit + 5}>
        {context => (
          <Wrapper>
            <Helmet>
              <title>Length | Wiha BitFinder</title>
            </Helmet>
            <h2>Choose your Length</h2>
            <Grid dual>
              <Checker bit={hexBit} usage={usage} stage={"length"} />
            </Grid>
          </Wrapper>
        )}
      </MainContext.Consumer>
    </>
  );
};

export default length;
